export default __webpack_public_path__ + "static/media/cmp_logo_auth.b42cb1da.png";